import { useMutation } from 'react-query';
import { MutationConfig, queryClient } from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';
import { axiosDefaultApi } from 'src/lib/axios';


const editOtellConType = ( {data, otellConTypeId} : {data: IPostEditOtellConType | {}, otellConTypeId: number}): Promise<string> => {
  return axiosDefaultApi.put(`/api/OteIIConTypes/UpdateOteIIConType/${otellConTypeId}`, data);
};

type QueryFnType = typeof editOtellConType;

type UseEditOtellConTypeOptions = {
  data: IPostEditOtellConType | {};
  otellConTypeId: number;
  config?: MutationConfig<QueryFnType>;
};

export const useEditOtellConType = ({ config }: UseEditOtellConTypeOptions) => { 
    const {addNotification, setIsNotificationVisible} = useNotification();
    return useMutation({
        onError: (error: any) => {
            addNotification(`Υπήρξε κάποιο πρόβλημα στην επεξεργασία του Είδους τηλεπ. γραμμής ΟΤΕ.`, 500);
            console.error('Couldnt edit OtellConType', error);
            setIsNotificationVisible(true)
          },
          onSuccess: () => {
            queryClient.invalidateQueries(["getAllOtellConTypes"])
            addNotification('Το Είδος τηλεπ. γραμμής ΟΤΕ Ενημερώθηκε.', 200);
            setIsNotificationVisible(true)
          },
        ...config,
        mutationFn: editOtellConType,
    })
}